/** Chart.js Registration in order to allow tree shaking */
import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PieController,
  PointElement,
  TimeScale,
  Tooltip
} from 'chart.js'
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap'
import annotationPlugin from 'chartjs-plugin-annotation'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import i18n from '@/plugins/i18n'
import router from '@/plugins/router'
import vuetify from '@/plugins/vuetify'

import 'chartjs-adapter-date-fns'

Chart.register(
  LineController, BarController, PieController,
  PointElement, LineElement, BarElement, ArcElement,
  LinearScale, CategoryScale, TimeScale,
  Tooltip, Legend, Filler
)
Chart.register(annotationPlugin)
Chart.register(TreemapController, TreemapElement)

const app = createApp(App)

app.use(i18n)
app.use(router)
app.use(createPinia())
app.use(vuetify)

app.mount('#app')
